import { ISelectOption, stringToNum, TSelectValue } from 'telia-front-react';
import { VAT_RATE } from '../util/PriceUtil';
import { RentCalculatorInputValues, RentCalculatorState, RentProps } from './PostpayInterfaces';

const getDepositSelectOptions = () => {
  const options = [];
  for (let i = 0; i <= 45; i += 5) {
    options.push({
      label: `${i}%`,
      value: `${i}`
    });
  }
  return options;
};

export const defaultCapitalRentProps: RentProps = {
  depositSelectInput: {
    options: getDepositSelectOptions(),
    value: {
      label: '0%',
      value: '0'
    }
  },
  maxContractFee: 100,
  maxInterestRate: 35,
  maxProductPrice: 5000,
  periodSlider: {
    range: {
      max: 48,
      min: 12
    },
    start: 12
  }
};

export const defaultUsageRentProps: RentProps = {
  ...defaultCapitalRentProps,
  periodSlider: {
    range: {
      max: 48,
      min: 6
    },
    start: 6
  }
};

export const getSelectionValue = (selectOption: TSelectValue): string => {
  if (selectOption && !Array.isArray(selectOption)) {
    return (selectOption as ISelectOption).value;
  } else {
    return '';
  }
};

export const calculateMonthlyPaymentForUsageRent = (inputValues: RentCalculatorInputValues): number => {
  const price: number = stringToNum(inputValues.productPrice);
  const deposit: number = inputValues.depositAmount;
  const period = Number(inputValues.period);
  const interest: number = stringToNum(inputValues.interestRate);
  if (!inputValues.buybackAmount) {
    return -1;
  }
  const buyBackAmount = inputValues.buybackAmount;

  if (interest === 0) {
    const contractFee: number = stringToNum(inputValues.contractFee);

    return (price + contractFee - deposit - buyBackAmount) / period;
  }

  const calc = interest / 100 / VAT_RATE / 12;

  return calc * ((price - deposit - buyBackAmount / (calc + 1) ** period) / (1 - 1 / (calc + 1) ** period));
};

export const calculateMonthlyPaymentForCapitalRent = (inputValues: RentCalculatorInputValues): number => {
  const price: number = stringToNum(inputValues.productPrice);
  const deposit: number = inputValues.depositAmount;
  const interest: number = stringToNum(inputValues.interestRate) + 0.000000001;
  const contractFee: number = stringToNum(inputValues.contractFee);
  const period = Number(inputValues.period);

  const calc1: number = (interest / 100 / 12) * (price - deposit + contractFee);
  const calc2: number = Math.pow(interest / 100 / 12 + 1, period);

  return calc1 / (1 - 1 / calc2);
};

export const getStateFromRentProps = (rentProps: RentProps): RentCalculatorState => {
  return {
    contractFee: rentProps.contractFee || '0',
    contractFeeError: false,
    depositSelection: rentProps.depositSelectInput?.value || null,
    depositSelectionValue: rentProps.depositSelectInput?.value ? getSelectionValue(rentProps.depositSelectInput?.value) : '',
    interestRate: rentProps.interestRate || '19,9',
    interestRateError: false,
    period: rentProps.periodSlider?.start,
    productPrice: rentProps.productPrice || '800',
    productPriceError: false
  };
};
